// @flow
import { Map } from 'immutable';
import { handleActions, type ActionType } from 'redux-actions';
import {
  requestChannelContent,
  receiveChannelContent,
  mountCollection,
  unmountCollection,
} from './channelContentActions';

type ChannelCollectionData = {
  items: Array<Id>,
  totalPages?: number,
};
type ChannelCollection = RequestStatus | Array<Id> | ChannelCollectionData;
type State = Map<string, ChannelCollection>;
const defaultState: State = new Map();

export type ChannelContentState = State;

// onMountCollection
// sets channel as pending content request
const onMountCollection = (state: State, action: ActionType<mountCollection>) =>
  state.set(action.payload, 'pending');

// onUnmountCollection
const onUnmountCollection = (
  state: State,
  action: ActionType<unmountCollection>
) => state.remove(action.payload);

// onRequestCollection
const onRequestCollection = (
  state: State,
  action: ActionType<requestChannelContent>
) => {
  const { channelName: key } = action.payload;
  const val: ChannelCollection = 'pending';

  return state.set(key, val);
};

// onReceiveCollection
const onReceiveCollection = (
  state: State,
  action: ActionType<receiveChannelContent>
) => {
  const { payload, meta: channelName } = action;

  return state.set(channelName, payload);
};

export default handleActions(
  {
    [mountCollection.toString()]: onMountCollection,
    [unmountCollection.toString()]: onUnmountCollection,
    [requestChannelContent.toString()]: onRequestCollection,
    [receiveChannelContent.toString()]: onReceiveCollection,
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/containers/channels/ducks/channelContentReducer.js